let ruleValidators = {
    // 非空校验
    null: function(labelName, message) {
        return function(rule, value, callback) {
            value = value == null ? '' : value;
            if (value.toString().trim() === '') {
                var errorInfo =
                    '请输入' + (message || labelName);
                callback(new Error(errorInfo));
            } else {
                callback();
            }
        };
    },

    // 邮箱校验
    email: function(labelName) {
        return function(rule, value, callback) {
            value = value == null ? '' : value;
            // const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/
            const reg = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+((\.[a-zA-Z0-9_-]{2,3}){1,2})$/;
            if (value !== '' && !reg.test(value)) {
                var errorInfo = '请输入正确的' + labelName;
                callback(new Error(errorInfo));
            } else {
                callback();
            }
        };
    },
    // qq号校验
    qq: function() {
        return function(rule, value, callback) {
            value = value == null ? '' : value;
        };
    },
    // 手机号-座机，校验
    phone: function(labelName) {
        return function(rule, value, callback) {
            value = value == null ? '' : value;

            //var isPhone = /^([0-9]{3,4}-)?[0-9]{7,8}$/
            var isPhone = /^0\d{2,3}-?\d{7,8}$/; //座机号
            //var isMob = /^((\+?86)|(\(\+86\)))?(13[012356789][0-9]{8}|15[012356789][0-9]{8}|18[02356789][0-9]{8}|147[0-9]{8}|1349[0-9]{7})$/
            var isMob = /^1[3456789]\d{9}$/; //手机号

            if (value !== '' && !isPhone.test(value) && !isMob.test(value)) {
                var errorInfo = '请输入正确的' + labelName;
                callback(new Error(errorInfo));
            } else {
                callback();
            }
        };
    },
    // 身份证校验
    idcard: function(labelName) {
        return function(rule, value, callback) {
            value = value == null ? '' : value;
            const reg = /^[1-9]\d{5}(19[4-9]|20[0,1])\d(0[1-9]|1[0-2])([0-2][0-9]|30|31)\d{3}[\d|X|x]$/;
            if (value !== '' && !reg.test(value)) {
                var errorInfo = '请输入正确的' + labelName;
                callback(new Error(errorInfo));
            } else {
                callback();
            }
        };
    },
    // 数字校验
    integer: function(labelName) {
        return function(rule, value, callback) {
            value = value == null ? '' : value;
            //const reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
            const reg = /^\d+(\.{0,1}\d+){0,1}$/;
            if (value !== '' && !reg.test(value)) {
                var errorInfo = labelName + '请输入正确的数字';
                callback(new Error(errorInfo));
            } else {
                callback();
            }
        };
    },
    //字段编码校验
    fieldcode: function(labelName) {
        return function(rule, value, callback) {
            value = value == null ? '' : value;
            //const reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/
            const reg = /^[a-zA-Z][0-9a-zA-Z]*$/g;
            if (value !== '' && !reg.test(value)) {
                callback(new Error('请输入正确的字段编码(字母开头数字组合)!'));
            } else {
                callback();
            }
        };
    },
};

export default {
    methods: {
        validate(item = {}) {
            // 字段名称
            var labelName = item.labelName
            item.required = item.required === undefined ? true : item.required

            let rules = []
            // 没传就默认必输，传入了false就可以不用校验必填
            if (item.required) {
                rules.push({
                    required: item.required,
                    validator: ruleValidators.null(item.labelName,item.message),
                    trigger: 'blur'
                })
            }
            if (item.max) {
                rules.push({
                    min: 1,
                    max: item.max,
                    message: '字段:"'+labelName + '"最大长度为' + item.max + '个字符!',
                    trigger: 'blur'
                })
            }
            if (item.min && item.max) {
                rules.push({
                    min: item.min,
                    max: item.max,
                    message:
                        labelName +
                        '长度在' +
                        item.min +
                        '至' +
                        item.max +
                        '之间!',
                    trigger: 'blur'
                })
            }
            if (item.type) {
                var rule = [
                    {
                        required: item.required,
                        validator: ruleValidators.null(
                            item.labelName,
                            item.message
                        ),
                        trigger: 'blur',
                    },
                    {
                        validator: ruleValidators[item.type](
                            labelName
                        ),
                        trigger: 'blur',
                    },
                ];
                rules = rules.concat(rule)
            }
            return rules
        }
    }
}
